import { Fragment } from 'react';

import { useHistory } from 'react-router-dom';
import routes from '../../../constants/routes';

// components
import CompanyLogo from '../../../assets/images/logo.png';
import UILink from '../../../components/Buttons/UILink';
import NewPasswordForm from './NewPasswordForm';

// styles
import styles from '../styles.module.scss';

// redux
import { useDispatch } from 'react-redux';
import { doChangePassword } from '../../../redux/thunks/authentication';
import Footer from '../../../components/Footer';
import FlexColumn from '../../../components/FlexBox/FlexColumn';
import FlexRow from '../../../components/FlexBox/FlexRow';
import Typography from '../../../components/Typography/Typography';

const NewPassword = () => {
  const dispatch = useDispatch();

  const history = useHistory();
  const displayLeftSection = () => (
    <div className={styles['left_section']}>
      <div className={styles['login_image']}></div>
    </div>
  );

  const handlesubmit = (values) => {
    dispatch(doChangePassword());
  };

  const displayRightSection = () => (
    <FlexColumn justifyContent='flex-start' flexWrap='nowrap' className={styles['right_section']}>
      <FlexRow alignItems='end'>
        <img style={{ width: '8rem' }} src={CompanyLogo} alt="Spintly" />
        <Typography variant={"h2M"}> | Partner</Typography>
      </FlexRow>
      <FlexColumn justifyContent='start' styles={{ height: '70dvh' }}>
        <FlexColumn>
          <Typography variant={"b1M"} color='var(--info-700)'>Since this is your first time here we will need you to set a new password</Typography>
          <NewPasswordForm handleResetPassword={handlesubmit} />
        </FlexColumn>
        <Footer />
      </FlexColumn>
    </FlexColumn>
  );

  return (
    <FlexColumn styles={{ position: 'relative', overflow: 'hidden' }}>
      <FlexColumn flexWrap='nowrap' styles={{ height: '100dvh', zIndex: '1' }}>
        <FlexRow alignItems='end'>
          <img style={{ width: '8rem' }} src={CompanyLogo} alt="Spintly" />
          <Typography variant={"h2M"}> | Partner</Typography>
        </FlexRow>
        <FlexColumn justifyContent='start' styles={{ width: '30rem', maxWidth: '95%' }}>
          <Typography variant={"b1M"} color='var(--info-700)'>Since this is your first time here we will need you to set a new password</Typography>
          <NewPasswordForm handleResetPassword={handlesubmit} />
          <Footer />
        </FlexColumn>
      </FlexColumn>
      <div className={styles['w-circle']} />
    </FlexColumn>
  );
};

export default NewPassword;
